import { render, staticRenderFns } from "./App.vue?vue&type=template&id=65e0325e&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0325e",
  null
  
)

export default component.exports